import { render, staticRenderFns } from "./DeleteTeacher.vue?vue&type=template&id=f7bb00de&scoped=true"
import script from "./DeleteTeacher.vue?vue&type=script&lang=js"
export * from "./DeleteTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bb00de",
  null
  
)

export default component.exports